import HelpCenterRoundedIcon from "@mui/icons-material/HelpCenterRounded";
import { colors } from "@mui/material";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

interface IColumnHeaderProperties {
  title: string;
  tooltip?: string;
}

export default function ColumnHeader({ title, tooltip = "" }: IColumnHeaderProperties) {
  return (
    <Tooltip placement="top" title={tooltip || ""}>
      <Box alignItems="center" display="flex" flexGrow={1} gap="0.125rem">
        {tooltip && (
          <HelpCenterRoundedIcon
            sx={{
              color: colors.blue[600],
              fontSize: "1rem",
            }}
          />
        )}
        <Typography sx={{ fontWeight: 600 }} variant="subtitle2">
          {title}
        </Typography>
      </Box>
    </Tooltip>
  );
}
